import React from 'react';
import './HowItWorks.css';

const steps = [
  {
    title: "We have a free 30-minute call",
    desc: "Tell us about your business in plain English. What's broken, what's slow, what's keeping you up at night. No forms, no homework, no preparation needed. Just a conversation.",
    tip: "You don't need to know anything about technology. That's our job. You just need to know your business.",
  },
  {
    title: "We show you exactly what we'd fix \u2014 and what it's worth",
    desc: "Within a week, you get a plain-English report: here are your biggest time and money leaks, here's what automation would do about each one, here's what you'd save. No obligation to go further.",
    tip: "Real numbers, specific to your business. Not a generic brochure. An honest, practical plan.",
  },
  {
    title: "We set everything up while you carry on working",
    desc: "We connect the tools, build the automations, set up the systems \u2014 all of it. You don't touch a single setting. We test everything before it goes live and train you and your team in under an hour.",
    tip: "Most businesses are running within 3\u20134 weeks. You'll feel the difference in week one.",
  },
  {
    title: "We stay with you as your business grows",
    desc: "Every month we review what's working, spot new opportunities, and keep everything running smoothly. Technology is moving fast \u2014 we make sure your business stays ahead without you having to keep up.",
    tip: "Think of us as your technology department. Without the salary, desk, or HR headache.",
  },
];

const HowItWorks: React.FC = () => {
  return (
    <section className="journey" id="how">
      <div className="journey-inner">
        <div className="journey-head reveal">
          <span className="eyebrow">How it works</span>
          <h2>Four steps. <em>No tech</em><br />knowledge needed.</h2>
          <p>You run your business. We handle the technology side. Completely.</p>
        </div>
        <div className="journey-steps">
          {steps.map((step, i) => (
            <div className="j-step reveal" key={i}>
              <div className="j-num">{i + 1}</div>
              <div className="j-body">
                <h3>{step.title}</h3>
                <p>{step.desc}</p>
                <div className="j-tip">{step.tip}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
